<template>
  <section class="bd-wrapper">
    <ul class="breadcrumb">
      <li
        v-for="(item, key) in list"
        :key="key"
        class="tx-medium tx-black"
        :class="[
          { 'current-page': key === list.length - 1 }
        ]"
      >
        <a @click="routeTo(item)">{{ item.name }}</a>
        <span v-if="key < list.length - 1">></span>
      </li>
    </ul>
  </section>
</template>

<script src="./js/breadcrumb.js"></script>

<style lang="scss" scoped>
@import '@blibli/blue-design-tokens/dist/tokens-default.scss';
@import '@blibli/blue-dls-utils/dist/scss/responsive-mixins-helper';

.bd-wrapper {
  ul.breadcrumb {
    display: flex;

    @include mobile {
      padding-inline: 16px;
    }

    li {
      a, span {
        color: $blu-color-info-text-default;
      }

      span {
        margin-inline: .6rem;
      }
    }

    .current-page {
      font-weight: 600;
      a {
        color: $blu-color-neutral-text-med;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          cursor: default;
        }
      }
    }
  }
}

.job-details section,
.application-form section,
.application-tracking section {
  @include desktop {
    padding-top: 4.8rem;
  }
}
</style>
